import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  // Enforce that the user explicitly typed the secret phrase during this session
  const isUnlocked = sessionStorage.getItem('adminUnlocked') === 'true';

  // Check if user exists, has the admin flag, AND typed the phrase
  return user && user.isAdmin && isUnlocked ? children : <Navigate to="/" replace />;
};

export default AdminRoute;